import React from "react";
import classnames from "classnames";
import { propToCssModule } from "~/Classes/styles";
import ButtonNew from "~/Common-Objects/UI/Button";
import DropdownMenu from "~/Common-Objects/UI/DropdownMenu";
import * as styles from "./index.module.scss";

const InboxButton = React.forwardRef(
  ({ variant, iconOnly, className, dropDownOptions = [], dropDownChange = () => { }, dropDownSelected = "",
    popupAlign = "start",
    popupMinWidth = 240, ...rest }, forwardedRef) => {
    const classes = classnames(styles.root, className, {
      [styles[`rootVariant${propToCssModule(variant)}`]]: variant,
      [styles.rootIconOnly]: iconOnly,
    });

    const buttonStyle = {};
    if (dropDownOptions && dropDownOptions.length > 0) {
      dropDownOptions = dropDownOptions.filter(f => f.value != dropDownSelected)
    }
    if (dropDownOptions && dropDownOptions.length > 0) {
      buttonStyle.borderTopRightRadius = 0;
      buttonStyle.borderBottomRightRadius = 0;
      buttonStyle.backgroundColor = "var(--neutral-950)";
      buttonStyle.border = "1px solid var(--neutral-950)";
    }

    return (<div style={{ display: "flex", alignItems: "stretch" }}>
      <ButtonNew
        ref={forwardedRef}
        variant={variant}
        iconOnly={iconOnly}
        className={classes}
        {...rest}
        style={buttonStyle}
      />
      {(dropDownOptions && dropDownOptions.length > 0) && <DropdownMenu.Root>
        <DropdownMenu.Trigger variant="dark" size="s" disabled={rest.disabled} style={{
          borderTopLeftRadius: "0",
          borderBottomLeftRadius: "0",
          padding: "5px 8px",
          borderWidth: "0 0 0 1px",
          borderLeftColor: "var(--neutral-700)"
        }}></DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content align={popupAlign} style={{ minWidth: popupMinWidth }}>
            <DropdownMenu.RadioGroup value={1}>
              {dropDownOptions.map((option, index) => {
                return <DropdownMenu.RadioItem
                  key={"sendOpt_" + index}
                  value={option.value}
                  onClick={() => { dropDownChange(option.value) }}
                >
                  <div className={styles.checkboxItemDetail}>
                    <span className={styles.checkboxItemInboxName}>
                      {option.label}
                    </span>

                  </div>
                </DropdownMenu.RadioItem>
              })}

            </DropdownMenu.RadioGroup>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root >}
    </div>
    );
  }
);

export default InboxButton;
